module.exports = __webpack_public_path__ + "img/14.c3ac2dfb.png";